import * as React from 'react';
import { Button, View, Text, StyleSheet } from 'react-native';
import Follow from '../components/Shared/Follow';
import Networks from '../components/Shared/Networks';
import { themePattern } from '../constants/pattern';
import { PropsStackShared, RootStackParamList } from './../types';


export default function Shared({ navigation }: PropsStackShared) {
  return (
    <View style={styles.Main}>
      <View style={styles.top}>
        <Follow key={1} />
      </View>
      <View style={styles.down}>

        <Networks key={2} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  Main: {
    padding:15,
    margin: 15,
    textAlign: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    flex:1,
    
  },
  top: {
    borderColor: themePattern.mobile.black,
    borderStyle: 'solid',
    flex:1,
    borderWidth: 2,
    borderBottomWidth: 1,
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
  },
  down: {
    borderColor: themePattern.mobile.black,
    borderStyle: 'solid',
    flex:1,
    borderWidth: 2,
    borderTopWidth: 1,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    backgroundColor: themePattern.mobile.color1,
  }
});